export default "__VITE_ASSET__CK$_OLAN__"